<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2s"><a id="page_vi"></a><a id="page_vii"></a><span class="small">CONTENTS</span></h2>
<p class="toc"><a href="#/xhtml/illustrations#ill"><em>List of Illustrations</em></a></p>
<p class="toc"><a href="#/xhtml/acknowledgments#ack"><em>Acknowledgments</em></a></p>
<p class="toc"><a href="#/xhtml/introduction#int">Introduction</a></p>
<p class="toct"><a href="#/xhtml/chapter01#ch1">1 Truths That Are Not Self-Evident: The Revolution in Political Speech</a></p>
<p class="toct"><span href="#/xhtml/chapter02#ch2" title="Link target outside of Sample">2 We Have Not Yet Begun to Write: Historians and Founders Chic</span></p>
<p class="toct"><span href="#/xhtml/chapter03#ch3" title="Link target outside of Sample">3 We the Tourists: The Revolution at Museums and Historical Sites</span></p>
<p class="toct"><span href="#/xhtml/chapter04#ch4" title="Link target outside of Sample">4 Give Me <em>Liberty’s Kids</em>: How the Revolution Has Been Televised and Filmed</span></p>
<p class="toct"><span href="#/xhtml/chapter05#ch5" title="Link target outside of Sample">5 To Re-create a More Perfect Union: Originalism, the Tea Party, and Reenactors</span></p>
<p class="toc"><span href="#/xhtml/conclusion#con" title="Link target outside of Sample">Conclusion</span></p>
<p class="toc"><span href="#/xhtml/readings#fur" title="Link target outside of Sample"><em>Further Readings</em></span></p>
<p class="toc"><span href="#/xhtml/index#ind" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span href="#/xhtml/author#abo" title="Link target outside of Sample"><em>About the Author</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?d5e7e97a